import { render, staticRenderFns } from "./TokenLogin.vue?vue&type=template&id=06d8d2f5&"
import script from "./TokenLogin.vue?vue&type=script&lang=js&"
export * from "./TokenLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports